module.exports = __webpack_public_path__ + "static/media/Danielle St Louis Head Shot.e741c4b3.png";